import React, { useCallback } from 'react';
import { CodeOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Menu, Spin } from 'antd';
import { FormattedMessage, history, useIntl, useModel } from '@umijs/max';
import { stringify } from 'querystring';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
import { outLogin } from '@/services/tconnect/auth';
import type { MenuInfo } from 'rc-menu/lib/interface';
import { getToken, logoutToken } from '@/utils/token';
import access from '@/access';

export type GlobalHeaderRightProps = {
  menu?: boolean;
};

/**
 * 退出登录，并且将当前的 url 保存
 */
const loginOut = async () => {
  const auth = getToken();
  await outLogin({
    token: auth.accessToken,
  });
  const { query = {}, search, pathname } = history.location;
  const { redirect } = query;
  logoutToken();
  // Note: There may be security issues, please note
  if (window.location.pathname !== '/auth/login/' && !redirect) {
    history.replace({
      pathname: '/auth/login/',
      search: stringify({
        redirect: pathname + search,
      }),
    });
  }
};

const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu }) => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const checkAccess = access(initialState);
  const intl = useIntl();

  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event;
      if (key === 'logout') {
        setInitialState((s) => ({ ...s, currentUser: undefined }));
        loginOut();
        return;
      }
      history.push(`/${key}/`);
    },
    [setInitialState],
  );

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.username) {
    return loading;
  }

  const menuHeaderDropdown = (
    <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
      {menu && (
        <>
          <Menu.Item key="profile">
            <UserOutlined />
            <FormattedMessage id="pages.account.header.info" defaultMessage="Thông tin cá nhân" />
          </Menu.Item>
          {checkAccess.developApi && (
            <Menu.Item key="developer">
              <CodeOutlined />
              <FormattedMessage id="pages.account.header.developer" defaultMessage="Developer" />
            </Menu.Item>
          )}
        </>
      )}
      {menu && <Menu.Divider />}

      <Menu.Item key="logout">
        <LogoutOutlined />
        {intl.formatMessage({
          id: 'pages.login.logout',
          defaultMessage: 'Đăng xuất',
        })}
      </Menu.Item>
    </Menu>
  );
  return (
    <HeaderDropdown overlay={menuHeaderDropdown}>
      <span className={`${styles.action} ${styles.account}`}>
        <Avatar
          size="small"
          className={styles.avatar}
          src={
            currentUser.avatar ||
            'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png'
          }
          alt="avatar"
        />
        <span className={`${styles.name} anticon`}>{currentUser.username}</span>
      </span>
    </HeaderDropdown>
  );
};

export default AvatarDropdown;
